import React from 'react'
import Image from "next/legacy/image"

export const imageLoader = ({ src, width, quality }) => {
  return `${src}?auto=compress,format&fit=max&w=${width}&q=${quality || 40}`
}

function NextImage({
  width,
  height,
  layout,
  url,
  local,
  alternativeText,
  objectFit,
}) {
  const src = !url
    ? null
    : url.startsWith('http') || local
    ? url
    : `${process.env.API_URL}${url}`

  return url ? (
    <Image
      src={src}
      layout={layout}
      alt={alternativeText}
      loader={imageLoader}
      objectFit={objectFit}
      {...(layout === 'fill' ? {} : { width, height })}
    />
  ) : null
}

NextImage.defaultProps = { layout: 'intrinsic' }

export default NextImage
